<template>
  <el-dialog
    title="修改提单价格"
    :visible.sync="defaultVisible"
    width="1200px"
    :close-on-click-modal="false"
  >
    <vxe-table
      border
      show-overflow
      auto-resize
      resizable
      :data="storageLadingPickingPrice"
      :edit-config="editConfig"
      :edit-rules="changePriceTableRules"
      size="mini"
      ref="changePriceTable"
      :valid-config="{ autoPos: true, message: 'inline' }"
      keep-source
      :max-height="$store.state.app.tableHeight"
    >
      <!-- <vxe-table-column type="checkbox" width="60" fixed="left"></vxe-table-column> -->
      <vxe-table-column
        type="seq"
        width="60"
        :title="this.$t('salesBill.batchMatchingResults.table.seq')"
      ></vxe-table-column>
      <vxe-table-column
        field="contractDetailNo"
        :title="this.$t('salesBill.batchMatchingResults.table.contractDetailNo')"
        width="60"
      ></vxe-table-column>
      <vxe-table-column
        field="productDesc"
        :title="this.$t('salesBill.batchMatchingResults.table.productDesc')"
        width="140"
      ></vxe-table-column>
      <vxe-table-column
        field="ladingQuantity"
        :title="this.$t('salesBill.batchMatchingResults.table.ladingQuantity')"
      >
      </vxe-table-column>
      <vxe-table-column field="originChangingUnitPrice" title="修改前单价"> </vxe-table-column>
      <vxe-table-column field="originLadingAmount" title="修改前金额"> </vxe-table-column>
      <vxe-table-column
        field="businessChangingUnitPrice"
        title="修改后单价"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number
            :max="999999999.999999"
            :min="0"
            v-model="scope.row.businessChangingUnitPrice"
            @change="(val) => businessChangingUnitPriceChange(val, scope.row, scope)"
            :clearable="true"
            :precision="$globalVar.pPoint"
          ></input-number>
        </template>
        <template v-slot="scope">
          {{
            $baseRequest.formatTableColumn(scope.row.businessChangingUnitPrice, $globalVar.pPoint)
          }}
        </template>
      </vxe-table-column>
      <vxe-table-column field="businessLadingAmount" title="修改后金额"> </vxe-table-column>
    </vxe-table>
    <div style="margin-top: 10px">
      <el-form ref="changeReasonForm" :rules="rules" label-width="120px" :model="changeReasonForm">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="修改价格原因" prop="changeReason">
              <el-select
                style="width: 100%"
                v-model="changeReasonForm.changeReason"
                placeholder="请选择修改价格原因"
                filterable
                clearable
              >
                <el-option
                  v-for="item in changeReasonList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('salesBill.message.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{
        $t('salesBill.message.confirm')
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import inputNumber from '@/components/form-item/input-number';
  import { toFixedNumber } from '@/common/js/util';
  import DataBaseAPI from '@/api/dataBase';
  import API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill.js';

  export default {
    props: {
      ladingNo: {
        type: String,
        default: () => '',
      },
      ladingId: {
        type: String,
        default: () => '',
      },
    },
    components: {
      inputNumber,
    },
    watch: {},
    data() {
      return {
        defaultVisible: false,
        tableToolbar: {},
        editConfig: { trigger: 'click', mode: 'row' },
        storageLadingPickingPrice: [],
        changeReasonForm: {
          changeReason: '',
        },
        changeReasonList: [], //修改价格原因
        rules: {
          changeReason: [{ required: true, message: '请选择修改价格原因', trigger: 'change' }],
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      changePriceTableRules() {
        return {
          businessChangingUnitPrice: [
            {
              required: true,
              message: '修改后单价必填',
              trigger: ['change', 'blur'],
            },
          ],
        };
      },
    },
    created() {},
    mounted() {
      this.getDic();
    },
    methods: {
      toFixedNumber,
      getDic() {
        let tenantCode = this.userInfo.tenantCode;
        //修改价格原因
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'price_change_reason',
            tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.changeReasonList = res.data.data;
            }
          });
      },
      async getPriceDetail() {
        this.defaultVisible = true;
        this.loading.startLoading();
        await this.$axios
          .post(API.GET_CHANGE_PRICE_LIST, {
            ladingNo: this.ladingNo,
          })
          .then((res) => {
            this.loading.endLoading();
            if (res.data.code === 0) {
              this.storageLadingPickingPrice = res.data.data.storageLadingPickingPriceList;
            } else {
              this.$alert(res.data.msg);
              this.defaultVisible = false;
              this.loading.endLoading();
            }
          })
          .catch(() => {
            this.defaultVisible = false;
            this.loading.endLoading();
          });
      },
      businessChangingUnitPriceChange(val, row, scope) {
        if (val || val == 0) {
          scope.row.businessChangingUnitPrice = val;
        } else {
          scope.row.businessChangingUnitPrice = 0;
        }
        row.businessLadingAmount = this.$cal.calCommon(
          row.ladingQuantity,
          row.businessChangingUnitPrice,
          '*',
          'amount'
        );
        this.$refs.changePriceTable.updateStatus();
      },

      // 弹窗确认
      handleConfirm() {
        const productValid = new Promise((resolve) => {
          this.$refs.changePriceTable.validate((valid) => {
            if (valid) resolve();
          });
        });
        const changeReasonFormValid = new Promise((resolve) => {
          this.$refs.changeReasonForm.validate((valid) => {
            if (valid) resolve();
          });
        });
        Promise.all([productValid, changeReasonFormValid]).then(async () => {
          this.loading.startLoading();
          let tableData = this.$refs.changePriceTable.getTableData().fullData;
          let params = {
            id: this.ladingId,
            ladingNo: this.ladingNo,
            changeReason: this.changeReasonForm.changeReason,
            storageLadingPickingPriceList: tableData,
          };
          await this.$axios
            .post(API.SUBMIT_PRICE, params)
            .then((res) => {
              this.loading.endLoading();
              if (res.data.code == 0) {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'success',
                });
                this.defaultVisible = false;
                this.$emit('returnPath');
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
                this.defaultVisible = true;
              }
            })
            .catch(() => {
              this.loading.endLoading();
              this.$message({
                showClose: true,
                message: '系统异常，请联系管理员',
                type: 'error',
              });
              this.defaultVisible = true;
            });
        });
      },
      // 弹窗关闭
      close() {
        this.$refs.changeReasonForm.resetFields();
        this.defaultVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .inputWidth {
    width: 100% !important;
  }
  .tabContent {
    padding: 10px;
    background-color: #fff;
  }
  .break-space {
    white-space: nowrap;
    line-height: 18px;
  }
  // .el-select-dropdown__empty{
  //   display: none;
  // }
</style>
